const pants = {
  areas: [
    {
      id: 1,
      slug: 'base',
      name: 'ベース'
    },
    {
      id: 2,
      slug: 'decoration',
      name: '装飾'
    }
  ],
  elements: [
    {
      id: 1,
      slug: 'plain',
      name: '無地',
      area_id: 1,
    },
    {
      id: 2,
      slug: 'stripe',
      name: 'ストライプ',
      area_id: 1,
    },
    {
      id: 3,
      slug: 'switch',
      name: '切り返し',
      area_id: 2,
    },
    {
      id: 4,
      slug: 'line',
      name: 'ライン',
      area_id: 2,
    },
  ],
  items: [
    {
      id: 1,
      slug: 'plain',
      element_id: 1
    },
    {
      id: 2,
      slug: 'stripe',
      element_id: 2,
      color: '#525353'
    },
    {
      id: 3,
      slug: 'stripe',
      element_id: 2,
      color: '#D8004E'
    },
    {
      id: 4,
      slug: 'stripe',
      element_id: 2,
      color: '#00599E'
    },
    {
      id: 5,
      slug: 'stripe',
      element_id: 2,
      color: '#00256A'
    },
    {
      id: 6,
      slug: 'switch1',
      element_id: 3
    },
    {
      id: 7,
      slug: 'switch2',
      element_id: 3
    },
    {
      id: 8,
      slug: 'switch3',
      element_id: 3
    },
    {
      id: 9,
      slug: 'switch4',
      element_id: 3
    },
    {
      id: 10,
      slug: 'switch5',
      element_id: 3
    },
    {
      id: 11,
      slug: 'switch6',
      element_id: 3
    },
    {
      id: 12,
      slug: 'line',
      element_id: 4
    },
  ],
}
export default pants
